export const anyNamedEntity = {
	Name: "Any",
	__typename: "_Virtual"
};
